import { useLocation } from "react-router-dom";

import {
  BreadCrumb,
  Banner,
  HeadingTitle,
  SubHeadingTitle,
} from "../../../components/shared/index";

import styles from "./contact.module.css";

import {
  FaEnvelope,
  FaPhoneAlt,
  FaAddressBook,
} from "react-icons/fa";

import toast from "react-hot-toast";

import { useContactUsMutation } from "../../../queries/useContactUs";

import { useForm } from "react-hook-form";

import BackToTop from "../../../components/BackToTop/backtotop";

import {
  validateName,
  validateEmail,
  validateSubject,
  validateMessage,
} from "../../../utils/Validations";


const Contact = () => {
  const { pathname } = useLocation();

  const parts = pathname.split("/");

  const newPath = parts[parts.length - 2];


  // ======================================================
  // REACT HOOK FORM
  // ======================================================

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: "",
      email: "",
      subject: "",
      message: "",
    },

    // Validate when user submits
    mode: "onSubmit",
  });


  // ======================================================
  // CONTACT API
  // ======================================================

  const {
    mutateAsync: contactSend,
    isPending,
  } = useContactUsMutation();


  // ======================================================
  // SUBMIT
  // ======================================================

  const handleMessageSend = async (data) => {
    try {
      console.log("FORM DATA:", data);

      const response = await contactSend(data);

      toast.success(
        response?.data?.message ||
          "Message sent successfully"
      );

      reset();

    } catch (error) {
      console.error("CONTACT API ERROR:", error);

      toast.error(
        error?.response?.data?.message ||
          "Oops! Message send failed"
      );
    }
  };


  // ======================================================
  // VALIDATION ERROR
  // ======================================================

  const handleValidationError = (formErrors) => {
    console.log(
      "FORM VALIDATION ERRORS:",
      formErrors
    );
  };


  return (
    <section className={styles.contact__wrapper}>

      {/* ==================================================
          BREADCRUMB + BANNER
      ================================================== */}

      <BreadcrumbBanner
        newPath={newPath}
        heading="save on your skin prescription  get flast 20% OFF on all doctor prescribed tablets"
        imageUrl="https://t3.ftcdn.net/jpg/05/99/10/78/240_F_599107807_kaOhz5mux2kdVfhKZzdnFeDPgZUSlL32.jpg"
      />


      {/* ==================================================
          MAP
      ================================================== */}

      <MapLocation />


      <div className={styles.contactDetails__wrapper}>

        {/* ==================================================
            CONTACT FORM
        ================================================== */}

        <div className={styles.contact__form}>

          <HeadingTitle
            text="Tell Us Your Message"
            style={styles.contact__title}
          />


          <form
            onSubmit={handleSubmit(
              handleMessageSend,
              handleValidationError
            )}
          >

            {/* ============================================
                NAME
            ============================================ */}

            <div className={styles.form__group}>

              <label>
                Your Name <span>*</span>
              </label>

              <input
                type="text"
                placeholder="Enter your name"
                maxLength={50}
                {...register("name", {
                  validate: validateName,
                })}
              />

              {errors.name && (
                <p className={styles.error}>
                  {errors.name.message}
                </p>
              )}

            </div>


            {/* ============================================
                EMAIL
            ============================================ */}

            <div className={styles.form__group}>

              <label>
                Your Email <span>*</span>
              </label>

              <input
                type="email"
                placeholder="Enter your email"
                {...register("email", {
                  validate: validateEmail,
                })}
              />

              {errors.email && (
                <p className={styles.error}>
                  {errors.email.message}
                </p>
              )}

            </div>


            {/* ============================================
                SUBJECT
            ============================================ */}

            <div className={styles.form__group}>

              <label>
                Subject
              </label>

              <input
  type="text"
  placeholder="Enter subject"
  maxLength={80}
  {...register("subject", {
    validate: validateSubject,
  })}
/>

{errors.subject && (
  <p className={styles.error}>
    {errors.subject.message}
  </p>
)}

            </div>


            {/* ============================================
                MESSAGE
            ============================================ */}

            <div className={styles.form__group}>

              <label>
                Your Message <span>*</span>
              </label>

              <textarea
                rows="5"
                placeholder="Type your message"
                maxLength={250}
                {...register("message", {
                  validate: validateMessage,
                })}
              />

              {errors.message && (
                <p className={styles.error}>
                  {errors.message.message}
                </p>
              )}

            </div>


            {/* ============================================
                SUBMIT
            ============================================ */}

            <button
              type="submit"
              className={styles.submit__btn}
              disabled={isPending}
            >
              {isPending
                ? "Sending..."
                : "Send"}
            </button>

          </form>

        </div>


        {/* ==================================================
            CONTACT INFORMATION
        ================================================== */}

        <div className={styles.contact__info}>

          <HeadingTitle
            text="Contact Us"
            style={styles.info__title}
          />

          <SubHeadingTitle
            subTitle="Thank you for shopping with us! For any concerns, suggestions, or support requests, please don’t hesitate to contact us."
            style={styles.info__desc}
          />


          {/* ADDRESS */}

          <div className={styles.info__block}>

            <FaAddressBook
              className={styles.info__icon}
            />

            <div>

              <h4>Address</h4>

              <p>
                3rd Floor, OPP: HDFC Bank,
                Plot.No:-98, Venkateshwara Enclave,
                Suchitra 'X' Road, Hyderabad - 500067.
              </p>

            </div>

          </div>


          {/* PHONE */}

          <div className={styles.info__block}>

            <FaPhoneAlt
              className={styles.info__icon}
            />

            <div>

              <h4>Contact</h4>

              <p>
                Phone:&nbsp;

                <a href="tel:+918886060799">
                  +91 8886060799
                </a>
              </p>

              <p>
                WhatsApp:&nbsp;

                <a
                  href="https://wa.me/918886060799"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Chat on WhatsApp
                </a>
              </p>

            </div>

          </div>


          {/* EMAIL */}

          <div className={styles.info__block}>

            <FaEnvelope
              className={styles.info__icon}
            />

            <div>

              <h4>Email</h4>

              <p>

                <a
                  href="mailto:info@gdrbtechnologies.com"
                >
                  info@gdrbtechnologies.com
                </a>

              </p>

            </div>

          </div>

        </div>

      </div>

    </section>
  );
};


// ======================================================
// BREADCRUMB + BANNER
// ======================================================

const BreadcrumbBanner = ({
  newPath,
  heading,
  imageUrl,
}) => (
  <>
    <BreadCrumb
      customPaths={[
        {
          label: "Contact",
          path: newPath,
        },
      ]}
    />

    <Banner
      heading={heading}
      imageUrl={imageUrl}
    />
  </>
);


// ======================================================
// GOOGLE MAP
// ======================================================

const MapLocation = () => {
  return (
    <div className={styles.map__wrapper}>

      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3805.1673527673083!2d78.47180607332092!3d17.499522899568685!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb9b2ba4ecf09b%3A0xd999abc2b0474a76!2sGDRB%20Technologies%20Pvt%20Ltd!5e0!3m2!1sen!2sin!4v1776234280999!5m2!1sen!2sin"
        width="800"
        height="600"
        style={{
          border: 0,
        }}
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title="GDRB Technologies Location"
      />

      <BackToTop />

    </div>
  );
};


export default Contact;